import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import { Sidebar } from "primereact/sidebar";
import './JustificationSidebarStyles.scss';

export interface JustificationProps {
    header: string;
    message: string;
    style?: React.CSSProperties;
    visible: boolean;
    onHide: () => void;
    isReadOnly: boolean;
    reasons: any[];
    selectedReasonIds: any[];
    userReason: string;
    onReasonChange: (e: any) => void;
    onUserReasonChange: (val: string) => void;
    onSave?: () => void;
    loading?: boolean;
}

export default function JustificationSideBar({
    header,
    message,
    style,
    visible,
    onHide,
    isReadOnly,
    reasons,
    selectedReasonIds,
    //userReason,
    onReasonChange,
    //onUserReasonChange,
    onSave,
    loading = false
}: JustificationProps) {
return (
    //handle this popup properly
    <Sidebar
        position="right"
        visible={visible}
        style={{
            width: '450px',
            boxShadow: '0 0 10px rgba(0,0,0,0.2)',
            borderRadius: '8px 0 0 8px',
            padding: '0',
            ...style
        }}
        onHide={onHide}
        className="justification-sidebar"
        showCloseIcon={false}
    >
        <div className="comments-sidebar-header" style={{ padding: '1.5rem 1rem 1rem 1rem', borderBottom: '1px solid #eee' }}>
            <h3 style={{ margin: 0, fontSize: '1.25rem', fontWeight: 600 }}>{header}</h3>
            <Button
                        onClick={onHide}
                        icon="pi pi-times"
                        size="small"
                        rounded
                        outlined
                        severity="secondary"
                        aria-label="Cancel"
                      />
        </div>
        <div className="comments-sidebar-content" style={{ padding: '1rem' }}>
            <div style={{ marginTop: '1.5rem', marginBottom: '1rem' }}>
                <p className="justification-message">{message}</p>
            </div>
            {loading ? (
                <div style={{ color: 'gray', marginBottom: '1rem' }}>
                    Loading failed reasons...
                </div>
            ) : reasons.length === 0 ? (
                <div style={{ color: 'gray', marginBottom: '1rem' }}>
                    No failed reasons available for this measure.
                </div>
            ) : (
                reasons.map((reason: any) => (
                    <div key={reason.reasonId} className="flex align-items-center" style={{ marginBottom: '0.75rem' }}>
                        <Checkbox
                            inputId={'chkReason' + reason.reasonId}
                            name={'chkReason' + reason.reasonText}
                            value={reason.reasonId}
                            checked={selectedReasonIds.includes(reason.reasonId)}
                            onChange={onReasonChange}
                            disabled={isReadOnly}
                        />
                        <label htmlFor={'chkReason' + reason.reasonId} className="ml-2" style={{ fontSize: '1rem', color: '#444' }}>
                            {reason.reasonText}
                        </label>
                    </div>
                ))
            )}
            <div style={{ height: '16px' }} />
            {/* <div className="comments-form" style={{ margin: '1.5rem 0' }}>
                <InputTextarea
                    value={userReason}
                    onChange={(e) => !isReadOnly && onUserReasonChange(e.target.value)}
                    autoResize
                    rows={5}
                    cols={70}
                    disabled={isReadOnly}
                    style={{ width: '100%', fontSize: '1rem', borderRadius: '6px' }}
                />
            </div> */}
        </div>
        <div className="comments-sidebar-footer" style={{ padding: '1.5rem 1rem 1rem 1rem', borderTop: '1px solid #eee', display: 'flex', justifyContent: 'flex-end' }}>
            <Button
                onClick={onSave}
                disabled={isReadOnly || selectedReasonIds.length === 0}
                className="justification-save-btn"
                style={{ width: '100%' }}
            >
                Save Justification
            </Button>
        </div>
    </Sidebar>
);
}